import Icon, {iconColor, iconTypes} from "./Icon.jsx";
import {Localization, createLocalization} from "../util/localization.jsx";
import {Tab, TabList, TabPanel, Tabs} from "./Tabs.jsx";
import {Tag, tagTypes} from "./Tag.jsx";
import {TitleTab, TitleTabs} from "./TitleTabs.jsx";

import Calendar from "./Calendar.jsx";
import ContentWrapper from "./ContentWrapper.jsx";
import DropDownList from "./DropDownList.jsx";
import LabelField from "./LabelField.jsx";
import React from "react";
import ResponsiveColumn from "./ResponsiveColumn.jsx";
import ResponsiveRows from "./ResponsiveRows.jsx";
import Switch from "./Switch.jsx";
import TextField from "./TextField.jsx";
import {connect} from "react-redux";
import moment from "moment";

class ComponentsShowCase extends React.PureComponent {
    constructor(props){
        super(props);
		
        this.state = {
            inputText: "",
            selectedValue: null
        };

        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);

        const previousDates = [];
        const validDates = [];

        const m = moment().startOf("day");
        m.subtract(1, "days");
        m.subtract(2, "weeks");
        previousDates.push(m.clone());
        m.add(3, "days");
        previousDates.push(m.clone());
        m.add(4, "days");
        previousDates.push(m.clone());
        m.add(3, "days");
        previousDates.push(m.clone());
        m.add(4, "days");
        previousDates.push(m.clone());
        
        for (let i = 0; i < 10; i++) {
            m.add(3, "days");
            validDates.push(m.clone());
            m.add(4, "days");
            validDates.push(m.clone());
        }

        this.state = {
            switchChecked: false,
            calendarDate: moment().add(2, "days").format("YYYY-MM-DD"),
            previousDates: previousDates.map(d => d.format("YYYY-MM-DD")),
            validDates: validDates.map(d => d.format("YYYY-MM-DD")),
            nextOrderDate: moment().add(2, "days").format("YYYY-MM-DD")
        };

        this.onSwitchChange = this.onSwitchChange.bind(this);
        this.onSelectDate = this.onSelectDate.bind(this);
    }

    onSwitchChange(value) {
        this.setState({
            switchChecked: value
        });
    }

    onSelectDate(date) {
        this.setState({
            calendarDate: date
        });
    }

    onChangeText(change) {
        this.setState(change);
    }

    onChangeSelect(change) {
        this.setState(change);
    }

    render(){
        const {localization} = this.props;

        const options1 = [
            {
                value: null,
                label: "",
            },
            {
                value: "New York",
                label: "New York",
            },
            {
                value: "Dublin",
                label: "Dublin",
            },
            {
                value: "California",
                label: "California",
            },
            {
                value: "Istanbul",
                label: "Istanbul",
            },
            {
                value: "Izmir",
                label: "Izmir",
            },
            {
                value: "Oslo",
                label: "Oslo",
            }
        ];
        const options2 = [
            {
                value: true,
                label: "True",
            },
            {
                value: false,
                label: "False",
            }
        ];
        const options3 = [
            {
                value: null,
                label: "null",
            },
            {
                value: 0,
                label: "-- 0 --",
            },
            {
                value: 1,
                label: "-- 1 --",
            },
            {
                value: 2,
                label: "-- 2 --",
            }
        ];
        return (
            <ContentWrapper>
                <div style={{margin:"10px", marginTop:"30px"}}>
                    <TitleTabs>
                        <TitleTab label={"Products"} url={"/components/products"} deviceType="lg"/>
                        <TitleTab label={"Lists"} url={"/components/lists"} deviceType="lg"/>
                    </TitleTabs>
                    <div className="card-default">
                        <Tabs>
                            <TabList>
                                <Tab label={"Title 1 with info"} />
                                <Tab label={"Title 2 with info"} />
                                <Tab label={"Title 3 with info"} />
                                <Tab label={"Title 4 with info"} />
                            </TabList>

                            <TabPanel>
                                <h2>Any content 1</h2>
                            </TabPanel>
                            <TabPanel>
                                <h2>Any content 2</h2>
                            </TabPanel>
                            <TabPanel>
                                <h2>Any content 3</h2>
                            </TabPanel>
                            <TabPanel>
                                <h2>Any content 4</h2>
                            </TabPanel>
                        </Tabs>
                    </div>
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12}>
                            <Calendar localization={localization} date={this.state.calendarDate} validDates={this.state.validDates} previousDates={this.state.previousDates} nextOrderDate={this.state.nextOrderDate} onSelectDate={this.onSelectDate}/>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12}>
                            <label className="label16bold">
                                BUILD
                            </label>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={6} sm={4}>
                            <div className="card-default" style={{height:"44px"}}>
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={6} sm={4}>
                            <div className="card-general-message" style={{height:"44px"}} >
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={6} sm={4}>
                            <div className="card-warning" style={{height:"44px"}} >
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={6} sm={4}>
                            <div className="card-icon">
                                <Icon type={iconTypes.itemList} />
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12} sm={8}>
                            <div className="card-default">
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={12}>
                                        <ResponsiveRows>
                                            <ResponsiveColumn xs={6} sm={3}>
                                                <button className={"btn primary"} onClick={undefined}  disabled={false}>
                                                    PRIMARY
                                                </button>
                                            </ResponsiveColumn>
                                            <ResponsiveColumn xs={6} sm={3}>
                                                <button className={"btn"} onClick={undefined}  disabled={false}>
                                                    SECONDARY
                                                </button>
                                            </ResponsiveColumn>
                                            <ResponsiveColumn xs={6} sm={4}>
                                                <button className={"btn icon"} onClick={undefined}  disabled={false}>
                                                    <Icon type={iconTypes.plus} color={iconColor.red}/>
                                                    SECONDARY
                                                </button>
                                            </ResponsiveColumn>
                                            <ResponsiveColumn xs={6} sm={2}>
                                                <button className={"btn circular"} onClick={undefined}  disabled={false}>
                                                    <Icon type={iconTypes.plus} color={iconColor.red}/>
                                                </button>
                                            </ResponsiveColumn>
                                        </ResponsiveRows>
                                    </ResponsiveColumn>
                                    <br />
                                    <ResponsiveColumn xs={12}>
                                        <ResponsiveRows>
                                            <ResponsiveColumn xs={3}>
                                                <button className={"btn primary"} onClick={undefined}  disabled={true}>
                                                    PRIMARY
                                                </button>
                                            </ResponsiveColumn>
                                            <ResponsiveColumn xs={3}>
                                                <button className={"btn"} onClick={undefined}  disabled={true}>
                                                    SECONDARY
                                                </button>
                                            </ResponsiveColumn>
                                            <ResponsiveColumn xs={4}>
                                                <button className={"btn icon"} onClick={undefined}  disabled={true}>
                                                    <Icon type={iconTypes.plus} color={iconColor.red}/>
                                                    SECONDARY
                                                </button>
                                            </ResponsiveColumn>
                                            <ResponsiveColumn xs={2}>
                                                <button className={"btn circular"} onClick={undefined}  disabled={true}>
                                                    <Icon type={iconTypes.plus} color={iconColor.red}/>
                                                </button>
                                            </ResponsiveColumn>
                                        </ResponsiveRows>
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} sm={4}>
                            <div className="card-dark">
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={12}>
                                        <button className={"btn icon negative"} onClick={undefined}  disabled={false}>
                                            <Icon type={iconTypes.plus} color={iconColor.red}/>
                                            SECONDARY
                                        </button>
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                                {"-"}
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={12}>
                                        <button className={"btn icon negative"} onClick={undefined}  disabled={true}>
                                            <Icon type={iconTypes.plus} color={iconColor.red}/>
                                            SECONDARY
                                        </button>
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12} sm={6}>
                            <div className="card-default">
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={6}>
                                        <TextField onEdit={this.onChangeText} iconType={iconTypes.message} source={this.state} property={"tf1"}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField onEdit={this.onChangeText} iconType={iconTypes.message} source={this.state} property={"tf2"} locked={true}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField onEdit={this.onChangeText} source={this.state} property={"tf3"} isValid={true} iconType={iconTypes.message} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField onEdit={this.onChangeText} source={this.state} property={"tf4"} isValid={true} iconType={iconTypes.message} locked={true}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField onEdit={this.onChangeText} source={this.state} property={"tf5"} isValid={false} iconType={iconTypes.message} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField onEdit={this.onChangeText} source={this.state} property={"tf6"} isValid={false} iconType={iconTypes.message} locked={true}/>
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                                <div className="hr"/>
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={6}>
                                        <TextField value="Input te" onEdit={this.onChangeText} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField value="Input te" onEdit={this.onChangeText} disabled={true} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField value="Input tex" onEdit={this.onChangeText} isValid={true} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <TextField value="Input tex" onEdit={this.onChangeText} isValid={true} disabled={true} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="A label16bold" />
                                        <TextField value="Input text" onEdit={this.onChangeText} isValid={false} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="" />
                                        <TextField value="Input text" onEdit={this.onChangeText} isValid={false} disabled={true} />
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                                <div className="hr"/>lassName="hr"/>
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="Input mandatory" isRequired={true} />
                                        <TextField value="Input texte" onEdit={this.onChangeText} isValid={true}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="Input mandatory" isRequired={true} />
                                        <TextField value="Input texte" onEdit={this.onChangeText} isValid={true} disabled={true}/>
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="Input mandatory" isRequired={true} />
                                        <TextField value="Input texter" onEdit={this.onChangeText} isValid={true} iconType={iconTypes.message} isEditable={false}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="Input mandatory" isRequired={true} />
                                        <TextField value="Input texter" onEdit={this.onChangeText} isValid={true} iconType={iconTypes.message} isEditable={false} disabled={true}/>
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} sm={6}>
                            <div className="card-default">
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="Input mandatory" isRequired={true} />
                                        <DropDownList options={options1} onEdit={this.onChangeSelect} source={this.state} property={"selectedValue"}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <LabelField label="Input" isRequired={false} />
                                        <DropDownList options={options2} onEdit={this.onChangeSelect} source={this.state} property={"selectedValue"} nullText={"Select bolean"}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                        <DropDownList options={options3} onEdit={this.onChangeSelect} source={this.state} property={"selectedValue"} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={6}>
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                                <div className="hr"/>lassName="hr"/>
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={4}>
                                        <Tag type={tagTypes.red} label={"Red"} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={4}>
                                        <Tag type={tagTypes.grey} label={"Grey"} />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={4}>
                                        <Tag type={tagTypes.green} label={"Green"} />
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                    <ResponsiveRows>
                        <ResponsiveColumn xs={4}>
                            <Switch checked={this.state.switchChecked} onChange={this.onSwitchChange} checkedLabel="On" uncheckedLabel="Off"/>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={4}>
                            <Switch checked={true} disabled checkedLabel="Disabled" uncheckedLabel="Disabled"/>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={4}>
                            <Switch checked={false} disabled checkedLabel="Disabled" uncheckedLabel="Disabled"/>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            </ContentWrapper>
        );
    }
}

ComponentsShowCase.propTypes = {
    localization: Localization.propTypes.isRequired
};

const mapStateToProps = state => {
    return {
        localization: createLocalization(state)
    };
};

export default connect(mapStateToProps)(ComponentsShowCase);